import { render, staticRenderFns } from "./AllPrograms.vue?vue&type=template&id=b48bb538&scoped=true&"
import script from "./AllPrograms.vue?vue&type=script&lang=js&"
export * from "./AllPrograms.vue?vue&type=script&lang=js&"
import style0 from "./AllPrograms.vue?vue&type=style&index=0&id=b48bb538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48bb538",
  null
  
)

export default component.exports